import * as Datefns from 'date-fns';
import { DateConstants } from '../constants';

export const getFormattedDateString = (
	date: Date | string,
	format = DateConstants.monthDateYear,
) => {
	if (!date) return;
	const newDateString = Datefns.format(date, format);
	return newDateString;
};
